import { Layout } from "antd";
import { Outlet } from "react-router-dom";

import { usePageConfig, RVSidebarItem } from "@regal-voice/ui";
import { TOP_LEVEL_PAGES_TITLE_MAP } from "App/routes/pageNames";
import { AppPagePaths } from "App/routes/paths";

import { AdminPaths } from "./paths";

import styles from "./AdminLayout.module.scss";

export default function AdminLayout(): JSX.Element {
    usePageConfig({ pageTitle: TOP_LEVEL_PAGES_TITLE_MAP[AppPagePaths.admin], showSidebar: false });

    const brandsPath = `${AppPagePaths.admin}/${AdminPaths.brands}`;
    const voicesPath = `${AppPagePaths.admin}/${AdminPaths.voices}`;
    const templatesPath = `${AppPagePaths.admin}/${AdminPaths.templates}`;

    return (
        <div className={styles.adminContainer}>
            <Layout.Sider collapsed={true} collapsedWidth={64} className={styles.sidebar}>
                <RVSidebarItem href={brandsPath} icon="bank" activeRoutes={[`${brandsPath}/*`]}>
                    Brands
                </RVSidebarItem>
                <RVSidebarItem href={voicesPath} icon="sound" activeRoutes={[`${voicesPath}/*`]}>
                    Voices
                </RVSidebarItem>
                <RVSidebarItem href={templatesPath} icon="file-text" activeRoutes={[`${templatesPath}/*`]}>
                    Templates
                </RVSidebarItem>
            </Layout.Sider>
            <div className={styles.content}>
                <Outlet />
            </div>
        </div>
    );
}
